<template>
  <div id="app">
    <el-container>
      <el-container>
        <el-aside width="160px">
          <Sidebar />
        </el-aside>
        <el-main>
          <router-view />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import Sidebar from '@/components/Sidebar.vue'

export default {
  components: {
    Sidebar
  }
}
</script>

<style lang="scss">
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

body {
  font: 14px/1.5 "Microsoft Yahei", "PingFang SC", "Hiragino Sans GB",
    "\5b8b\4f53", sans-serif;
  background: rgba(245, 247, 250, 1);
}

#app {
  width: 100%;
  height: 100%;
  > .el-container {
    height: 100%;
    > .el-container {
      > .el-aside {
        width: 160px;
        height: 100%;
        background: linear-gradient(
          180deg,
          rgba(22, 88, 219, 1) 0%,
          rgba(66, 192, 248, 1) 100%
        );
        color: #fff;
      }
      > .el-main {
        display: flex;
        flex-direction: column;
        padding: 0;
      }
    }
  }
}

textarea {
  font-family: inherit;
}

.flex-row {
  display: flex;
  flex: 1 1 0;
}

.flex-column {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
}

.flex-el-tabs {
  display: flex;
  flex-direction: column;
  flex: 1 1 0;
  > .el-tabs__content {
    flex: 1 1 0;
    overflow: hidden;
    display: flex;
    > .el-tab-pane {
      flex: 1 1 0;
      display: flex;
      overflow: auto;
      > div {
        flex: 1 1 0;
      }
    }
  }
}

a.cool-btn-primary {
  width: 90px;
  height: 32px;
  font-size: 12px;
  background: linear-gradient(
    134deg,
    rgba(29, 136, 243, 1) 0%,
    rgba(6, 187, 255, 1) 100%
  );
  box-shadow: 0px 2px 6px rgba(26, 144, 245, 0.51);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  text-decoration: none;
  i {
    display: flex;
    align-items: center;
    &::before {
      font-size: 16px;
      margin-right: 2px;
    }
  }
}

// 重置一些样式
.el-dialog__headerbtn {
  top: 15px !important;
}
.el-dialog__header {
  padding: 10px 20px !important;
  border-bottom: 1px solid #dcdfe6;
}
.el-dialog__body {
  padding: 20px !important;
}
</style>
